module.exports = __webpack_public_path__ + "img/eagle.59f0e301.png";